import { bpSizeMap } from '@dropbox/dig-components/hooks';
import { useMatchMedia } from 'signer-app/utils/use-match-media';
import { useSignerContext } from 'signer-app/signer-experience/signer-experience';

const drawerBreakpointMediaQuery =
  `(max-width: ${bpSizeMap.medium}px)` as const;

export function useShouldShowDrawer() {
  const drawerSize = useMatchMedia(drawerBreakpointMediaQuery);
  const { isMobileReady } = useSignerContext();
  return isMobileReady && drawerSize;
}
